import { ProjectWithMetadata } from "@nova/constants"
import { createPolygonKML } from "@nova/data-create-polygon-kml"
import { Line } from "@nova/protobuf"
import { decodeNumberToColor } from "@nova/serializer/src/client/util"
import { lineFeatures } from "./caltopo"

export const lineTransformer = (line: Line, project: ProjectWithMetadata) => {
    return {
        lineToKML: () => {
            return createPolygonKML(line.name, [
                {
                    coords: line.coordinates.map((c) => [c.longitude, c.latitude]),
                    color: line.outline
                        ? decodeNumberToColor(line.outline, { isKml: true })
                        : "FF1A1AE5",
                    fill: line.fill ? decodeNumberToColor(line.fill, { isKml: true }) : undefined,
                    width: line.width,
                },
            ])
        },
        lineToCalTopo: () => lineFeatures(line),
        entity: line,
        project,
    }
}
